const RESET_PLAYERS_AND_TEAMS_STATE = 'RESET_PLAYERS_AND_TEAMS_STATE';
const SHOW_LEGEND = 'SHOW_LEGEND';

export default {
    SHOW_LEGEND,
    RESET_PLAYERS_AND_TEAMS_STATE,
};
